import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { SearchFilterPipe } from 'src/app/pipes/search-filter/search-filter.pipe';

@Component({
  selector: 'app-drop-down',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, FormsModule, SearchFilterPipe],
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css']
})
export class DropDownComponent implements OnInit {
  @Input() lists! : Array<any>; // dropdown datas are reveived as input in form of array from child component
  @Output() dataEmit = new EventEmitter(); //emits the selected data from dropdown to child component
  @Input() dropDownWidth= ''; // width value for dropdown to increase/decrease width size
  @Input() dropDownHeight= ''; // increase/decrease the height of drop down box
  @Input() dropBorderRadius= '5px'; // to style the of the border;
  @Input() selectedData :any = 'Select'; // default value from array list can be sent in this variable
  @Input() controlName: string = '';
  @Input() multipleSelect: boolean = false; //SK03OCT24
  @Input() multipleSelectedData: Array<any> = []; //SK03OCT24
  @Input() multipleSelectedView: Array<any> = []; //SK03OCT24

  /*the 'errorValue' (or) 'defaultValue', any one can be used. If we want to display error while selecting the data, 
      then 'errorValue' variable can be used, else, if we want to select none from list, we can use default value*/
  @Input() errorValue = '';  
  @Input() defaultValue = '';
  @Input() isDisabled = false;
  @Input() isRequired = false; //  input property to indicate whether the dropdown is required or not
  @Input() isError: boolean = false;
  @Output() errorEmit = new EventEmitter();
  @Output() multipleSelectDataEmit = new EventEmitter(); //SK03OCT24

  //error message to be displayed if we displaying a error
  @Input() errorMessage = '';
  searchText = ""; //SK03OCT24

  private clickListener!: (event: MouseEvent) => void;


  constructor(private readonly elementRef: ElementRef) { }

  ngOnInit(): void {
    // add an event listener to the document object that listens for a click event.
     this.clickListener = this.handleDocumentClick.bind(this);
     document.addEventListener('click', this.clickListener);
  }
  
  ngOnDestroy(): void {
    // remove the event listener from the document object to prevent memory leaks
    document.removeEventListener('click', this.clickListener);
  }

  dropDown = false;
  showError = false;

  listValue(event: any, data:any, type:string){
    // SK03OCT24 dropdown from single or multiple select
    if(type==="singleSelect"){
      this.selectedData = data;
      this.dataEmit.emit({event: event, data:this.selectedData, controlName: this.controlName});
      this.isError = false;
    } else if(type==="multipleSelect"){
      let list = Array.from(this.multipleSelectedView);
      list.push(data)
      this.multipleSelectedView = new Set(list) as any ;
      this.multipleSelectDataEmit.emit({event: event, data:Array.from(this.multipleSelectedView), controlName: this.controlName});
      this.isError = false;
    }
  }

  // first check if the click event occurred inside the dropdown component or not by calling the contains method on the nativeElement property of the elementRef object. 
  // If the click event occurred outside the component, we set the dropDown property to false, which will close the dropdown
  private handleDocumentClick(event: MouseEvent): void {
    const isClickInside = this.elementRef.nativeElement.contains(event.target);
    if (!isClickInside) {
      this.dropDown = false;
    }
  }
  // when outside click if the selected data and error value is equlas then show the error message
  outsideClick(){
    if(this.selectedData == this.errorValue){
      this.isError = true;
      this.errorEmit.emit(true);
    }else{
      this.isError = false;
      this.errorEmit.emit(false);
    }
  }

  // SK03OCT24 removing the values, if multiple select values in filter, 
  removeSelectedFilter(data:string, index:number){
    let list = Array.from(this.multipleSelectedView);
    list.splice(index,1);
    this.multipleSelectedView = list as any;
    this.multipleSelectDataEmit.emit({data:Array.from(this.multipleSelectedView), controlName: this.controlName});
  }
}
